import {EditPermissions} from '../../../../../../../shared/models';
import {FormArray, UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {getEditTypes} from '../../../delegatorUtils';
import {newStepValue} from '../../../../../services/flowBuilder/utils/constants';
import {required, spaceOnName} from '../../../../../../../shared/utils';

export interface StepData {
    [index: string]: any;
}

export interface SwitchCaseNodeFormType {
    actionParams: any;
    actionResults: any;
}

export class SwitchCaseNode {
    action: {} = {};


    constructor(nodeType: string) {
        this.action = {
            'actionType': nodeType,
        };
    }

    static toForm(stepData: StepData): SwitchCaseNodeFormType {
        return {
            actionParams: this.getActionParamsForm(stepData),
            actionResults: this.getActionResultsForm(stepData),
        };
    }

    static getActionParamsForm(stepData: StepData) {
        const action = stepData.action;

        return {
            name: action?.name ? action.name : '',
            description: action?.description ? action.description : '',
            variable: action?.actionParams.variable ? action.actionParams.variable : '',
            isCaseSensitive: action?.actionParams.isCaseSensitive ? action.actionParams.isCaseSensitive : '',
        };
    }

    static getActionResultsForm(stepData: StepData) {
        const action = stepData.action;

        const actionResults = {
            options: [],
            other: action?.result.other ? action.result.other : newStepValue
        };
        if (action?.result) {
            const items = action.result;
            const titleVal = Object.keys(items);
            const size = titleVal.length;
            const stepVal = Object.values(items);
            for (let i = 0; i < size; i++) {
                if (titleVal[i] !== 'other') {
                     const optionsFormData = {
                        title: titleVal[i],
                        step: stepVal[i]
                    };
                     actionResults.options.push(optionsFormData);
                }
            }
        } else {
            actionResults.options.push({title: '', step: newStepValue});
        }

        return actionResults;
    }

    static getActionTemplate(editPermissions: EditPermissions): UntypedFormGroup {
        const {editFlows} = getEditTypes(editPermissions);

        return new UntypedFormGroup({
            name: new UntypedFormControl({
                value: '',
                disabled: !editFlows,
            }, [spaceOnName('Name can\'t contain space'), required('Name')]),
            description: new UntypedFormControl({
                value: '',
                disabled: !editFlows,
            }, [required('Description')]),
            variable: new UntypedFormControl({
                value: '',
                disabled: !editFlows,
            }, [required('Variable')]),
            isCaseSensitive: new UntypedFormControl(''),
        });
    }

    static getCaseTemplate(editPermissions: EditPermissions): UntypedFormGroup {
        const {editFlows} = getEditTypes(editPermissions);
        return new UntypedFormGroup({
            title: new UntypedFormControl({
                value: '',
                disabled: !editFlows,
            }, [required('Value')]),
            step: new UntypedFormControl(newStepValue)
        });
    }

    addActionDetails(name, description) {
        this.action = {
            name,
            description,
            ...this.action,
        };
    }

    addActionParams(variable: string, isCaseSensitive: boolean): void {
        this.action = {
            ...this.action,
            actionParams: {
                variable,
                isCaseSensitive,
            },
        };
    }

    addActionResults(results) {
        const result = this.populateResults(results);

        this.action = {
            ...this.action,
            result
        };
    }

    populateResults(results: any) {
        const result = {};

        for (let i = 0; i < results.options.length; i++) {
            result[results.options[i].title] = results.options[i].step;
        }
        result['other'] = results.other;
        return result;
    }

    get nodeData(): {} {
        return {
            action: this.action,
            'type': 'action',
            metadata: {
                nodeVersion: '1.2.0'
            }
        };
    }
}
